import { observer } from 'mobx-react-lite'
import { DownloadPreviewBtn } from 'widgets/PresentationMode/ui/info/ui/buttons/DownloadPreviewBtn'
import { InfoWrap } from 'widgets/PresentationMode/ui/info/ui/InfoWrap/InfoWrap'
import { getAttachmentFlags } from 'widgets/MediaLibrary/utils'
import { usePresentationModeContext } from 'widgets/PresentationMode'

export const InfoDocPreview = observer(() => {
  const presentationStore = usePresentationModeContext()
  const { currentAttachment } = presentationStore

  if (!currentAttachment) return null

  const { isVCardPresentationAvailable } = getAttachmentFlags(currentAttachment)

  if (isVCardPresentationAvailable) return null

  return (
    <InfoWrap
      rightActions={
        <>
          <DownloadPreviewBtn />
        </>
      }
    />
  )
})
